import { Privacy as App } from 'website'

const Privacy = () => {
  return <App />
}

export async function getStaticProps() {
  return { props: {} }
}

export default Privacy
